import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.LISTS_EMAIL_QUALITY_DATA_UPDATE:
      return action.listsQualityData 
    default:
      return state
  }
}

